import React from "react";


import { ReactSVG } from "react-svg"


import "./index.scss";


type ConnectButtonComponentProps = {
    buttonText: string;
    buttonIcon?: string;
    buttonDisabled?: boolean;
}


export const ConnectButtonComponent:React.FC<ConnectButtonComponentProps> = ({
    buttonText, buttonIcon, buttonDisabled
}) => {


    return (
        <button className={'connect-button-component' + (buttonDisabled ? ' connect-button-disabled' : '')}>
            {buttonIcon && <ReactSVG src={buttonIcon} wrapper={'span'} className={'connect-button-component__icon'} />}
            <span className={'connect-button-component__text'}>{buttonText}</span>
        </button>
    );

};


export default ConnectButtonComponent;
